
<template>
    <div>
        <div style="border: 1px solid #e9e9e9; border-radius: 1rem;">
            <q-card-section>
                <div class="text-bold" style="font-size: 16px;">
                    <!-- {{$t("stepper.title10")}} -->
                    {{$t("stepper.title10")}}
                    </div>
            </q-card-section>
            <q-separator style="margin: 0 0.75rem; width: auto;"/>
            <q-card-section>
                <div class="q-pb-md secondaryHeader" >
                   {{$t("Applicant-Address.title")}}
                   
                </div>
                <div class="row q-mb-md">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.add1")}}
                    </div>
                    <div class="col-xs-12 col-md-9 q-mb-md">
                        {{StoreStateAOD.AddressInformation.PermanentAddress.Address1}}
                    </div>
                </div>
                <div class="row q-mb-md">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.add2")}}
                    </div>
                    <div class="col-xs-12 col-md-9 q-mb-md">
                        {{StoreStateAOD.AddressInformation.PermanentAddress.Address2}}
                    </div>
                </div>
                <div class="row q-mb-md">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md ">
                   {{$t("Applicant-Address.add3")}}
                    </div>
                    <div class="col-xs-12 col-md-9 q-mb-md">
                        {{StoreStateAOD.AddressInformation.PermanentAddress.Address3?StoreStateAOD.AddressInformation.PermanentAddress.Address3: '-'}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.postcode")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md q-pr-md">
                        {{StoreStateAOD.AddressInformation.PermanentAddress.Postcode}}
                    </div>
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.city")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.AddressInformation.PermanentAddress.City}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.state")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md q-pr-md" v-if="StoreStateAOD.AddressInformation.PermanentAddress.State != ''" >
                        {{StoreStateAOD.AddressInformation.PermanentAddress.State}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md q-pr-md" v-if="StoreStateAOD.AddressInformation.PermanentAddress.StateForeign != ''" >
                        {{StoreStateAOD.AddressInformation.PermanentAddress.StateForeign}}
                    </div>
                 
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.country")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.AddressInformation.PermanentAddress.Country}}
                    </div>
                </div>

                 <q-separator v-if="StoreStateAOD.hideCorrespondenceAdd != false" style="margin: 0;"/>

                <div v-if="StoreStateAOD.hideCorrespondenceAdd != false">
                
                <div class="q-py-md secondaryHeader" >
                   {{$t("Applicant-Address.title2")}}
                </div>
                <div class="row q-mb-md">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.add1")}}
                    </div>
                    <div class="col-xs-12 col-md-9 ">
                        {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Address1}}
                    </div>
                </div>
                <div class="row q-mb-md">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.add2")}}
                    </div>
                    <div class="col-xs-12 col-md-9 ">
                        {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Address2}}
                    </div>
                </div>
                <div class="row q-mb-md">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.add3")}}
                    </div>
                    <div class="col-xs-12 col-md-9 ">
                        {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Address3}}
                    </div>
                </div>
                <div class="row ">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.postcode")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Postcode}}
                    </div>
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.city")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.AddressInformation.CorrespondenceAddress.City}}
                    </div>
                </div>
                <div class="row ">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.state")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md" v-if="StoreStateAOD.AddressInformation.CorrespondenceAddress.Country==='MALAYSIA'">
                        {{StoreStateAOD.AddressInformation.CorrespondenceAddress.State}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md" v-if="StoreStateAOD.AddressInformation.CorrespondenceAddress.Country!=='MALAYSIA'">
                        {{StoreStateAOD.AddressInformation.CorrespondenceAddress.StateForeign}}
                    </div>
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                   {{$t("Applicant-Address.country")}}
                    </div>
                    <div class="col-xs-12 col-md-3 q-mb-md">
                        {{StoreStateAOD.AddressInformation.CorrespondenceAddress.Country.label}}
                    </div>
                </div>
                </div>
            </q-card-section>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryAddressInformation',
    data() {
        return {
            StoreStateAOD : store.state.AOD
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>